import { MANAGEFEEDS_GET_DATA, DISPATCH_FEED_STATUS, DISPATCH_DELETE_FEED, DISPATCH_UPDATE_ACCOUNT } from './keys'
const initialState = { feeds: null, totalFeed: 0 }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case MANAGEFEEDS_GET_DATA: {
            const {feeds,totalFeeds} = action.payload;
            return { ...state, feeds: feeds, totalFeed: totalFeeds?totalFeeds:0 }
        }
        case DISPATCH_FEED_STATUS: {
            var feeds = changeStatus(action.payload, state.feeds);
            return { ...state, feeds }
        }
        case DISPATCH_DELETE_FEED: {
            var data = state.feeds.filter(x => x.id != action.payload)
            return { ...state, feeds: data, totalFeed: state.totalFeed - 1 }
        }
        case DISPATCH_UPDATE_ACCOUNT: {
            var feeds = changeAccount(action.payload, state.feeds);
            return { ...state, feeds }
        }
        default:
            return { ...state }
    }

}




const changeStatus = (PayloadData, feeds) => {
    let updatedScene = feeds;
    feeds.map((item, index) => {
        if (item.id == PayloadData.feedId) PayloadData.action == "moderation" ? item.moderation = PayloadData.status : item.status = PayloadData.status
    })
    return updatedScene;
}


const changeAccount = (PayloadData, feeds) => {
    let updatedScene = feeds;
    feeds.map((item, index) => {
        if (item.id == PayloadData.feedId) item.connectedAccount = PayloadData.accountId
    })
    return updatedScene;
}

